import React from "react";
import { Avatar, Button, Tag, Tooltip } from "antd";
import { EnvironmentOutlined } from "@ant-design/icons";
import { Localize } from "components/service";
import { timeFormat } from "utils/helper-functions";
import { getInitials, getPlatformMeta, getScanReasonLabel, getScanStatusMeta, hasScanLocation } from "./event-attendance-helper";

const getScanLocation = (log) => ({
    ...log,
    lat: log.latitude,
    lng: log.longitude,
});

const EventCheckInLogsTableHelper = (openLocation) => {
    const columns = [
        {
            title: <Localize>TABLES.Column_Title_Worker</Localize>,
            dataIndex: "worker",
            width: "16%",
        },
        {
            title: <Localize>TABLES.Column_Title_Subcontractor</Localize>,
            dataIndex: "subcontractor",
            width: "15%",
        },
        {
            title: <Localize>TABLES.Column_Title_ActionType</Localize>,
            dataIndex: "action",
            width: "10%",
        },
        {
            title: <Localize>TABLES.Column_Title_Time</Localize>,
            dataIndex: "time",
            width: "13%",
        },
        {
            title: <Localize>TABLES.Column_Title_Status</Localize>,
            dataIndex: "status",
            width: "9%",
        },
        {
            title: <Localize>TABLES.Column_Title_Reason</Localize>,
            dataIndex: "reason",
            width: "20%",
        },
        {
            title: (
                <Tooltip title={ <Localize>TABLES.Tooltip_AttendanceDevice</Localize> }>
                    <span><Localize>TABLES.Column_Title_Device</Localize></span>
                </Tooltip>
            ),
            dataIndex: "device",
            width: "11%",
        },
        {
            title: (
                <Tooltip title={ <Localize>TABLES.Tooltip_ScanLocation</Localize> }>
                    <span><Localize>TABLES.Column_Title_ScanLocation</Localize></span>
                </Tooltip>
            ),
            dataIndex: "location",
            align: "center",
            width: "6%",
        },
    ];

    const data = (logs) => {
        if (!logs)
        {
            return [];
        }

        return logs.map((log) => {
            const workerName = `${ log.worker.name } ${ log.worker.surname }`;
            const isCheckIn = log.action === "check_in";
            const status = getScanStatusMeta(log.status);
            const reason = getScanReasonLabel(log.reason);
            const platform = getPlatformMeta(log.platform);
            const canOpenLocation = hasScanLocation(log);

            return {
                key: log.id,
                worker: (
                    <span className="event-check-logs-worker">
                        <Avatar size={ 32 }>{ getInitials(log.worker) }</Avatar>
                        <span>{ workerName }</span>
                    </span>
                ),
                subcontractor: log.subcontractor.title,
                action: (
                    <Tag color={ isCheckIn ? "green" : "red" }>
                        { isCheckIn ?
                            <Localize>CHECK_LOGS.Tag_CheckIn</Localize> :
                            <Localize>CHECK_LOGS.Tag_CheckOut</Localize>
                        }
                    </Tag>
                ),
                time: timeFormat(log.created_at, "DD.MM.YYYY HH:mm:ss"),
                status: (
                    <Tag color={ status.color }>
                        <Localize>{ status.label }</Localize>
                    </Tag>
                ),
                reason: (
                    <span className="event-check-logs-reason">
                        <span>{ reason ? <Localize>{ reason }</Localize> : log.reason }</span>
                        { log.detail && <small>{ log.detail }</small> }
                    </span>
                ),
                device: (
                    <Tooltip title={ log.user_agent || log.ip || log.device_uuid }>
                        <span className="event-check-logs-device">
                            { platform.icon }
                            <span className="event-check-logs-device__text">
                                <span>{ platform.label }</span>
                                { log.device_uuid && <small>{ log.device_uuid }</small> }
                            </span>
                        </span>
                    </Tooltip>
                ),
                location: (
                    <Tooltip title={
                        canOpenLocation ?
                            <Localize>TABLES.Tooltip_ScanLocation</Localize> :
                            <Localize>CHECK_LOGS.Tooltip_NoScanLocation</Localize>
                    }>
                        <span>
                            <Button
                                type="text"
                                disabled={ !canOpenLocation }
                                icon={ <EnvironmentOutlined /> }
                                onClick={ () => openLocation(getScanLocation(log)) } />
                        </span>
                    </Tooltip>
                ),
            };
        });
    };

    return {
        columns,
        data,
    };
};

export default EventCheckInLogsTableHelper;
